















import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

@Component({})
export default class ContactsToggleLabel extends Vue {
  @Prop() label!: string;
  @Prop({ default: false }) shouldEnableToggle!: boolean;
  isCollapsed: boolean = true;

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
    this.emitOnToggle();
  }

  @Emit('toggleContactOptions')
  emitOnToggle() {
    return this.isCollapsed;
  }
}
